import EbzTable from './EbzTable';

export default EbzTable;
